'use client';

import { createContext, useContext } from 'react';
import type { ProjectModel } from '@/lib/models/Project';

export const ProjectsContext = createContext<ProjectModel[]>([]);

export function useProjects(): ProjectModel[] {
  return useContext(ProjectsContext);
}
